import { toRaw } from 'vue'

export const hasDamagePos = (item) => !!(item?.damagemappos?.x && item?.damagemappos?.y)

// Numbers follow the saved order of damage items, counting only those placed on the splat,
// which is how the inspection report numbers them too
export const damageNumbers = (items) => {
	const numbers = new Map()
	let n = 0

	for (const item of items || []) {
		if (hasDamagePos(item))
			numbers.set(toRaw(item), ++n)
	}

	return {
		get: (item) => numbers.get(toRaw(item)) || null,
		next: n + 1,
	}
}
